 
import React, { ReactElement } from 'react';

import { SkeletonBase } from '@digital-dealer/components';

const DesktopSkeleton = (): ReactElement => (
  <SkeletonBase viewBox="0 0 1200 680">
    <rect
      width="288"
      height="160"
      rx="4"
    />
    <rect
      y="172"
      width="288"
      height="16"
      rx="4"
    />
    <rect
      y="200"
      width="149"
      height="16"
      rx="4"
    />
    <rect
      x="304"
      width="288"
      height="160"
      rx="4"
    />
    <rect
      x="304"
      y="172"
      width="288"
      height="16"
      rx="4"
    />
    <rect
      x="304"
      y="200"
      width="149"
      height="16"
      rx="4"
    />
    <rect
      x="608"
      width="288"
      height="160"
      rx="4"
    />
    <rect
      x="608"
      y="172"
      width="288"
      height="16"
      rx="4"
    />
    <rect
      x="608"
      y="200"
      width="149"
      height="16"
      rx="4"
    />
    <rect
      x="912"
      width="288"
      height="160"
      rx="4"
    />
    <rect
      x="912"
      y="172"
      width="288"
      height="16"
      rx="4"
    />
    <rect
      x="912"
      y="200"
      width="149"
      height="16"
      rx="4"
    />
    <rect
      y="232"
      width="288"
      height="160"
      rx="4"
    />
    <rect
      y="404"
      width="288"
      height="16"
      rx="4"
    />
    <rect
      y="432"
      width="149"
      height="16"
      rx="4"
    />
    <rect
      x="304"
      y="232"
      width="288"
      height="160"
      rx="4"
    />
    <rect
      x="304"
      y="404"
      width="288"
      height="16"
      rx="4"
    />
    <rect
      x="304"
      y="432"
      width="149"
      height="16"
      rx="4"
    />
    <rect
      x="608"
      y="232"
      width="288"
      height="160"
      rx="4"
    />
    <rect
      x="608"
      y="404"
      width="288"
      height="16"
      rx="4"
    />
    <rect
      x="608"
      y="432"
      width="149"
      height="16"
      rx="4"
    />
    <rect
      x="912"
      y="232"
      width="288"
      height="160"
      rx="4"
    />
    <rect
      x="912"
      y="404"
      width="288"
      height="16"
      rx="4"
    />
    <rect
      x="912"
      y="432"
      width="149"
      height="16"
      rx="4"
    />
    <rect
      y="464"
      width="288"
      height="160"
      rx="4"
    />
    <rect
      y="636"
      width="288"
      height="16"
      rx="4"
    />
    <rect
      y="664"
      width="149"
      height="16"
      rx="4"
    />
    <rect
      x="304"
      y="464"
      width="288"
      height="160"
      rx="4"
    />
    <rect
      x="304"
      y="636"
      width="288"
      height="16"
      rx="4"
    />
    <rect
      x="304"
      y="664"
      width="149"
      height="16"
      rx="4"
    />
    <rect
      x="608"
      y="464"
      width="288"
      height="160"
      rx="4"
    />
    <rect
      x="608"
      y="636"
      width="288"
      height="16"
      rx="4"
    />
    <rect
      x="608"
      y="664"
      width="149"
      height="16"
      rx="4"
    />
    <rect
      x="912"
      y="464"
      width="288"
      height="160"
      rx="4"
    />
    <rect
      x="912"
      y="636"
      width="288"
      height="16"
      rx="4"
    />
    <rect
      x="912"
      y="664"
      width="149"
      height="16"
      rx="4"
    />
  </SkeletonBase>
);

export default DesktopSkeleton;
